import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/styles";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";

import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as yup from "yup";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpTabs: {
    marginTop: 30,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
    marginRight: 10,
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },
  warpData: {
    marginTop: 20,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: "#1094D8",
    color: "white",
  },
  iconStatus: {
    color: "#2DCE98",
    marginRight: 5,
  },
  warpButtonSave: {
    textAlign: "right",
    marginTop: 30,
  },
  buttonSave: {
    marginLeft: 5,
    width: 120,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  wrapDateControl: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: 15,
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  dateControl: {
    marginRight: 5,
    width: "100%",
  },
  btnEdit: {
    color: "white",
    backgroundColor: "#2DCE98",
    marginLeft: 10,
  },
  btnRemove: {
    color: "white",
    backgroundColor: "#F53C56",
    marginLeft: 10,
  },
  warpRowDialog: {
    marginTop: 10,
  },
  dtitle: {
    color: "#40B8D4",
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
}));

function AgencyListPage() {
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const dispatch = useDispatch();
  const [AgencyData, setAgencyData] = useState([]);
  const [dialogAdd, setDialogAdd] = useState(false);
  const [juristicStatus, setJuristicStatus] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/agencyregistered/list`
      );

      if (response.status) {
        setAgencyData(response.results);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const validationSchema = yup.object({
    juristicID: yup.string().required("กรุณากรอกเลขนิติบุคคล."),
    company_name: yup.string().required("กรุณากรอกชื่อบริษัท."),
    company_address: yup.string().required("กรุณากรอกที่อยู่."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      agencyRegisID: null,
      agency_no: "",
      juristicID: "",
      company_name: "",
      company_address: "",
    },
    onSubmit: async (c) => {
      const data = {
        agencyRegisID: c.agencyRegisID,
        agencyTaxID: c.juristicID,
        agencyRegisName: c.company_name,
        agencyRegisAddress: c.company_address,
        Status: true,
      };
      try {
        const response = await HttpClient.post(
          "/api/visaformadmin/agencyregistered/add",
          data
        );

        if (response.status) {
          alert("สำเร็จ");
          getData();
          formik.setFieldValue("juristicID", "");
          formik.setFieldValue("company_name", "");
          formik.setFieldValue("company_address", "");
          setDialogAdd(false);
          return response;
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    },
  });

  const checkISC = async (id) => {
    try {
      const response = await HttpClient.get(
        `/api/external/isc/company?juristicID=${id}`
      );

      if (response.status) {
        setJuristicStatus(true);
        formik.setFieldValue("company_name", response?.results?.companyName);
        formik.setFieldValue("company_address", response?.results?.address);
        return response;
      } else {
        alert("ไม่พบเลขนิติบุคคลดังกล่าว !");
        setJuristicStatus(false);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const detailAgency = async (id) => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/agencyregistered/list?agencyRegisID=${id}`
      );

      if (response.status) {
        response.results.map((x) => {
          formik.setFieldValue("agencyRegisID", x?.agencyRegisID);
          formik.setFieldValue("juristicID", x?.agencyTaxID);
          formik.setFieldValue("company_name", x?.agencyRegisName);
          formik.setFieldValue("company_address", x?.agencyRegisAddress);
          formik.setFieldValue("agency_no", x?.angecyNo);
        });

        setJuristicStatus(true);
        setDialogAdd(true);
        // setJuristicStatus(true);
        // formik.setFieldValue("company_name", response?.results?.companyName);
        // formik.setFieldValue("company_address", response?.results?.address);
        return response;
      } else {
        alert("ไม่พบตัวแทนดังกล่าว !");
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="ตัวแทน" />

      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="จัดการตัวแทน" />
        <div className={classes.wrapDateControl}>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            className={classes.buttonDialogSave}
            onClick={() => setDialogAdd(true)}
          >
            <AddIcon />
            เพิ่มตัวแทน
          </Button>
        </div>
      </div>

      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200 }}
                >
                  รหัสตัวแทน
                </StyledTableCell>
                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200 }}
                >
                  ชื่อตัวแทน
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Tax ID
                </StyledTableCell>
                {/* <StyledTableCell className={classes.tableHead}>
                    ใช้งาน
                  </StyledTableCell> */}

                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200, textAlign: "center" }}
                >
                  จัดการ
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {AgencyData.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>{row?.angecyNo}</StyledTableCell>
                  <StyledTableCell>{row?.agencyRegisName}</StyledTableCell>
                  <StyledTableCell>{row?.agencyTaxID}</StyledTableCell>
                  {/* <StyledTableCell className={classes.center}>
                      <Switch
                        checked={row?.status}
                        onChange={async (event) => {
                          const res = await DepartmentService.updateStatus({
                            empId: row?.empId,
                            status: event.target.checked,
                          });
                          if (res.status) {
                            await dispatch(
                              getMasterData({
                                department: true,
                              })
                            );
                          }
                        }}
                      />
                    </StyledTableCell> */}
                  <StyledTableCell style={{ width: 200, textAlign: "center" }}>
                    <div className={classes.warpButtonDetail}>
                      <Button
                        size="small"
                        color="primary"
                        className={classes.btnEdit}
                        onClick={() => {
                          detailAgency(row?.agencyRegisID);
                        }}
                      >
                        แก้ไข
                      </Button>
                      {/* <Button
                          size="small"
                          color="error"
                          className={classes.btnRemove}
                        >
                          ลบ
                        </Button> */}
                    </div>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <Dialog
        open={dialogAdd}
        minWidth="xl"
        fullWidth
        onClose={() => {
          formik.setFieldValue("agency_no", "");
          formik.setFieldValue("agencyRegisID", "");
          formik.setFieldValue("juristicID", "");
          formik.setFieldValue("company_name", "");
          formik.setFieldValue("company_address", "");
          setDialogAdd(false);
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          {formik.values.agency_no === "" ? (
            <DialogTitle>เพิ่มตัวแทน</DialogTitle>
          ) : (
            <DialogTitle>รหัสตัวแทน # {formik.values.agency_no}</DialogTitle>
          )}
          <DialogContent>
            <InputLabel>เลขนิติบุคคล</InputLabel>
            <div style={{ display: "flex", marginTop: 5 }}>
              <TextField
                variant="outlined"
                name="juristicID"
                fullWidth
                value={formik.values.juristicID}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("juristicID", formik)}
                disabled={formik.values.agencyRegisID !== null}
                helperText={getErrorMessage("juristicID", formik)}
              />
              {formik.values.agencyRegisID === null ? (
                <Button
                  size="small"
                  onClick={() => {
                    if (formik.values.juristicID !== "") {
                      checkISC(formik.values.juristicID);
                    } else {
                      alert("กรุณากรอกเลขนิติบุคคล");
                    }
                  }}
                  style={{ marginLeft: 5 }}
                  variant="outlined"
                >
                  Check
                </Button>
              ) : null}
            </div>
            <InputLabel>ชื่อบริษัท</InputLabel>
            <TextField
              variant="outlined"
              name="company_name"
              fullWidth
              style={{ marginTop: 5 }}
              value={formik.values.company_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError("company_name", formik)}
              helperText={getErrorMessage("company_name", formik)}
            />
            <InputLabel>ที่อยู่</InputLabel>
            <TextField
              variant="outlined"
              name="company_address"
              fullWidth
              multiline
              style={{ marginTop: 5 }}
              value={formik.values.company_address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError("company_address", formik)}
              helperText={getErrorMessage("company_address", formik)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                formik.setFieldValue("agency_no", "");
                formik.setFieldValue("agencyRegisID", "");
                formik.setFieldValue("juristicID", "");
                formik.setFieldValue("company_name", "");
                formik.setFieldValue("company_address", "");
                setDialogAdd(false);
              }}
            >
              ยกเลิก
            </Button>
            <Button type="submit" disabled={!formik.isValid || !juristicStatus}>
              ยืนยัน
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Paper>
  );
}

export default AgencyListPage;
